import { useEffect, useState } from "react";

import Popup from "../../components/Popup";
import { Input, Button } from "@qastanfit/qastan-ui"

import styles from "../../styles/base/Admin.module.scss";
import Detail from "../../components/Detail";
import EditPage from "../../components/admin/translations/EditPage";
import { useAppDispatch } from "../../hooks/redux";
import { setNotification } from "../../redux/actions";

export interface PageObject {
    [page: string]: {
        [key: string]: string
    };
}

export type MainObject = {
    KEYS: PageObject;
    N: PageObject;
    F: PageObject;
    E: PageObject
}

const Translations : React.FC = () => {
    const dispatch = useAppDispatch()

    const [show_newpage, setshow_newpage] = useState(false);
    const [show_detailpage, setshow_detailpage] = useState(false);
    const [selectedDetailPage, setselectedDetailPage] = useState("")

    const [newpage_name, setnewpage_name] = useState("");

    const [object, setobject] = useState<MainObject>({
        "KEYS": {},
        "N": {},
        "F": {},
        "E": {}
    });

    useEffect(()=>{
        getData()
    }, [])

    const getData = async () => {
        let f = await fetch(`${process.env.REACT_APP_SERVER_LINK}content`);
        let r = await f.json() as MainObject;
        setobject(r);
    }

    function stringToHexColor(input: string): string {
        let hash = 0;
        for (let i = 0; i < input.length; i++) {
          hash = input.charCodeAt(i) + ((hash << 5) - hash);
        }
        let color = '#';
        for (let i = 0; i < 3; i++) {
          let value = (hash >> (i * 8)) & 0xff;
          color += ('00' + value.toString(16)).substr(-2);
        }
        return color;
    }

    const addPage = async () => {
        let o = {...object};
        o.KEYS[newpage_name] = {}
        o.N[newpage_name] = {}
        o.F[newpage_name] = {}
        o.E[newpage_name] = {}

        setobject(o);
        setshow_newpage(false)

        let f = await fetch(`${process.env.REACT_APP_SERVER_LINK}content`, {
            method:'POST',
            body: JSON.stringify(object),
            headers: {'Content-Type': 'application/json'},
        })
        let r = await f.json();
    }

    const saveTranslations = async (object:MainObject) => {
        setobject(object);
        let f = await fetch(`${process.env.REACT_APP_SERVER_LINK}content`, {
            method:'POST',
            body: JSON.stringify(object),
            headers: {'Content-Type': 'application/json'},
        })
        let r = await f.json();
        if(r.errorcode === 0){
            dispatch(setNotification({type:"success", title:"Succes", message:"Wijzigingen opgeslagen"}))
        }
    }

    return (
    <>  
        {show_newpage && 
        <Popup>
            <div style={{padding:"2rem"}}>
                <p style={{fontWeight:"600", marginBottom:".5rem"}}>Hoe wil je de nieuwe pagina noemen?</p>
                <Input onChange={(target:HTMLInputElement) => {setnewpage_name(target.value)}} placeholder="Pagina naam..."/>
                <div style={{display:"flex", marginTop:"1rem", justifyContent:"flex-end"}}>
                    <Button onClick={()=>{setshow_newpage(false)}} kind="plain">Annuleren</Button>
                    <Button onClick={()=>{addPage()}}>Opslaan</Button>
                </div>
            </div>
        </Popup>
        }

        {show_detailpage &&
        <Detail onClose={()=>{setshow_detailpage(false)}}>
            <EditPage object={object} selectedPage={selectedDetailPage} onSave={(object)=>{saveTranslations(object)}}/>
        </Detail>
        }

        <div className={styles.translations}>
            <h1 className={styles.title}>Vertalingen</h1>
            <p className={styles.description}>Op deze pagina kun je alle content van de hele website aanpassen. Dit kan dienen voor andere vertalingen, een andere woordkeuze of misschien zelfs een hele zin die je wilt verwijderen.</p>
            <br></br>
            <h2 className={styles.subtitle}>Your pages</h2>

            <div className={styles.cards}>
                <div onClick={()=>{setshow_newpage(true)}} className={styles.card}>
                    <div className={styles.card_color} style={{backgroundColor:"gainsboro"}}></div>
                    <div className={styles.card_info}>
                        <p className={styles.card_title}>Nieuwe pagina</p>
                        <p className={styles.card_description}>Klik voor een nieuwe pagina</p>
                    </div>
                </div>

                {Object.keys(object.KEYS).map((page, index) => {
                    return (
                        <div onClick={()=>{setselectedDetailPage(page); setshow_detailpage(true)}} className={styles.card} key={index}>
                            <div className={styles.card_color} style={{backgroundColor:stringToHexColor(page)}}></div>
                            <div className={styles.card_info}>
                                <p className={styles.card_title}>{page}</p>
                                <p className={styles.card_description}>{Object.keys(object.KEYS[page]).length} zinnen/woorden</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    </>
    )
}

export default Translations